import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FontInlinePickerComponent } from './font-inline-picker/font-inline-picker.component';
import { ButtonModule } from 'ZalamoLibrary/src/lib/ui/button/button/button.module';
import { FontListComponent } from './font-list/font-list.component';
import { ListLoaderModule } from 'ZalamoLibrary/src/lib/ui/helpers/list-loader/list-loader/list-loader.module';
import { SideDialogModule } from 'ZalamoLibrary/src/lib/ui/side-dialog';
import { FontNamePipe } from './font-name.pipe';
import { MatIconModule } from '@angular/material/icon';
import { MatTabsModule } from '@angular/material/tabs';

@NgModule({
  declarations: [FontInlinePickerComponent, FontListComponent, FontNamePipe],
  exports: [FontInlinePickerComponent],
  imports: [
    CommonModule,
    ButtonModule,
    ListLoaderModule,
    SideDialogModule,
    MatIconModule,
    MatTabsModule,
  ],
})
export class FontsManagerModule {}
